import { useCallback } from "react";

const OFFSET = 20;

const clickHandler  = (node, event) => {
    node.scrollLeft = (event.target.offsetLeft - node.offsetLeft) - OFFSET;
}

export const useAutoScroll = (ref, childSelector) => {
    const focusItem = useCallback(() => {
        if(!ref.current) return;
        const node = ref.current;
        const childs = node.querySelectorAll(`.${childSelector}`);
        const callback = clickHandler.bind(null, node);
        childs.forEach(item => {
            item.addEventListener('click', callback);
        });
        return () => {
            childs.forEach(item => {
                item.removeEventListener('click', callback);
            });
        }
    }, [ref, childSelector, clickHandler]);
    return { focusItem };
}